import DynamicColorRowHtml      from '../../app-lite/grids/templates/row.dynamic-color.html';
import GridFooterHtml           from '../../app-lite/grids/templates/footer.html';
import ProductSearchResultsHtml from '../../app-lite/products/templates/product.search.results.html';
import StockTakeCountCellHtml   from './templates/stock_take_count_cell.html';
import VendorSearchResultsHtml  from '../../app-lite/vendors/templates/vendors.search.results.html';

export function StockTakeCtrl (
  $q,
  $rootScope,
  $scope,
  $state,
  $transitions,
  $translate,
  API,
  beginProduct,
  confirm,
  endProduct,
  gridAPI,
  jsonApi,
  locations,
  messages,
  products,
  product_groups,
  product_types,
  sessionObjAPI,
  streamSearch,
  vendor,
  workshopAPI
) {

  $scope.gridCache      = jsonApi.parse(localStorage.getItem('stocktakeGrid'));
  $scope.loaded         = true;
  $scope.locations      = locations;
  $scope.products       = products;
  $scope.product_types  = product_types;
  $scope.product_groups = product_groups;
  $scope.confirmNav     = true;
  $scope.session        = sessionObjAPI.base();
  $scope.company        = sessionObjAPI.company();
  $scope.showWarning    = true;

  $scope.paging = {
    pageSize   : 10,
    pageSizes  : [10, 25, 50, 100],
    currentPage: 1,
    count () {
      return workshopAPI.get('/stock_takes/count', [
        $scope.filters.product_type,
        $scope.filters.vendor,
        $scope.filters.begin_item,
        $scope.filters.end_item,
        $scope.filters.location,
        $scope.sorts.fields[0],
        $scope.sorts.directions[0],
        gridAPI.getOffset($scope.paging),
        gridAPI.getPageSize($scope.paging),
        $scope.filters.hide_zeros
      ], null, { query: { group: $scope.filters.product_group } });
    },
    lastPage () {
      gridAPI.lastPage(this);
    }
  };

  $scope.sorts = {
    directions: ['asc'],
    fields    : ['item_code']
  };

  $scope.filters = {
    begin_item             : '*',
    count_excludes_reserved: $scope.gridCache ? $scope.gridCache.filtering.count_excludes_reserved : false,
    end_item               : '*',
    hide_zeros             : false,
    location               : '*',
    product_group          : '*',
    location               : '*',
    product_type           : 'S',
    show_reserve           : $scope.gridCache ? $scope.gridCache.filtering.show_reserve : false,
    vendor                 : '*'
  };

  $scope.isReservedStock = (function () {
    return $scope.filters.show_reserve && $scope.session.gold_or_higher;
  });

  $scope.grid = {
    columnDefs: [
      {
        displayName   : $translate.instant('PRODUCT_SPACE.ITEM_CODE'),
        enableCellEdit: false,
        field         : 'product.item_code'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
        enableCellEdit: false,
        field         : 'product.description'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.GROUP'),
        enableCellEdit: false,
        field         : 'product.product_group_name'
      },
      {
        displayName   : $translate.instant('VENDOR_SPACE.SUPPLIER'),
        enableCellEdit: false,
        field         : 'product.company_name'
      },
      {
        displayName   : $translate.instant('PRODUCT_SPACE.LOCATION'),
        enableCellEdit: false,
        field         : 'product.location'
      },
      {
        displayName   : $translate.instant('JS_SPACE.COLUMNS.ON_HAND'),
        enableCellEdit: false,
        field         : 'product.quantity_on_hand',
        width         : '90px'
      },
      {
        displayName   : $translate.instant('JS_SPACE.COLUMNS.RESERVED'),
        enableCellEdit: false,
        field         : 'product.qty_reserved',
        width         : '90px'
      },
      {
        displayName   : $translate.instant('JS_SPACE.COLUMNS.QUANTITY_AVAILABLE'),
        enableCellEdit: false,
        field         : 'product.qty_available',
        width         : '90px'
      },
      {
        allowNull           : true,
        cellClass           : 'text-right',
        displayName         : $translate.instant('JS_SPACE.COLUMNS.COUNT'),
        editableCellTemplate: StockTakeCountCellHtml,
        enableCellEdit      : true,
        field               : 'stock_take.draft_quantity',
        sortable            : false,
        width               : '75px'
      }
    ],
    data                   : 'products',
    enableCellEditOnFocus  : true,
    enableCellSelection    : true,
    enableRowSelection     : false,
    filterOptions          : $scope.filters,
    footerTemplate         : GridFooterHtml,
    pagingOptions          : $scope.paging,
    rowHeight              : 43,
    rowTemplate            : DynamicColorRowHtml,
    showFooter             : true,
    sortInfo               : $scope.sorts,
    storageKey             : 'stocktakeGrid',
    useExternalSorting     : true,
    virtualizationThreshold: Math.max.apply(null, $scope.paging.pageSizes),
  };

  $scope.grid.columnDefs[6].visible = $scope.isReservedStock();
  $scope.grid.columnDefs[7].visible = $scope.isReservedStock();

  $scope.productSearch = {
    begin_item: beginProduct,
    end_item  : endProduct,
    list      : [],
    search (typed) {
      var _this = this;

      return streamSearch.search('products', typed)
      .then(products => _this.list.concat(products));
    },
    clear (field) {
      if (!this[field]) {
        $scope.filters[field] = '*';
      }
    },
    format (product) {
      return product ? product.item_code: '';
    },
    choose (item, filter) {
      $scope.filters[filter] = item.id;
    },
    templateUrl: ProductSearchResultsHtml
  };

  $scope.vendorSearch = {
    vendor: vendor,
    list  : [],
    search (typed) {
      var _this = this;

      return streamSearch.search('vendors', typed)
      .then(vendors => _this.list.concat(vendors));
    },
    clear (field) {
      if (!this[field]) {
        $scope.filters[field] = '*';
      }
    },
    format (vendor) {
      return vendor ? vendor.company_name: '';
    },
    choose (vendor) {
      $scope.filters.vendor = vendor.id;
    },
    templateUrl: VendorSearchResultsHtml
  };

  $scope.getPage = function () {
    return gridAPI.getPage('/stock_takes',[
      $scope.filters.product_type,
      $scope.filters.vendor,
      $scope.filters.begin_item,
      $scope.filters.end_item,
      $scope.filters.location,
      gridAPI.stripObj($scope.sorts.fields[0]),
      $scope.sorts.directions[0],
      gridAPI.getOffset($scope.paging),
      gridAPI.getPageSize($scope.paging),
      $scope.filters.hide_zeros,
      $scope.filters.count_excludes_reserved
    ], $scope.grid, { query: { group: $scope.filters.product_group } })
    .then(products => {
      $scope.products = products;

      return products;
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.getReportUrl = function () {
    return `${ API.url }/reports/stock_take_report/${ $scope.filters.product_type }/${ $scope.filters.vendor }/${ $scope.filters.begin_item }/${ $scope.filters.end_item }/${ $scope.filters.location }/${ $scope.sorts.fields[0] }/${ $scope.sorts.directions[0] }/${ $scope.filters.hide_zeros }?group=${ encodeURIComponent($scope.filters.product_group) }`;
  };

  $scope.getRowColor = function (item, column) {
    const classes = gridAPI.getColumnClasses(column);
    const count   = item.stock_take.draft_quantity;

    if (count || parseFloat(count) === 0) {
      classes.push('bg-success');
    }

    return classes;
  };

  $scope.hideWarning = function () {
    $scope.showWarning = false;
  };

  $scope.process = function () {
    confirm.generic($translate.instant('JS_SPACE.MESSAGES.PROCESS_THE_STOCKTAKE'))
    .then(() => $scope.savePage())
    .then(() => workshopAPI.get('/stock_takes/stock_take_process'))
    .then(() => sessionObjAPI.refresh())
    .then(() => {
      if ($scope.paging.currentPage !== 1) {
        $scope.paging.currentPage = 1;
      }
      else {
        $scope.getPage();
      }

      messages.show($translate.instant('STATUS_TYPES.PROCESSED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.saveDraft = function () {
    $scope.savePage()
    .then(() => $scope.getPage())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.DRAFT'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.savePage = function () {
    const stock_takes = $scope.products.filter(item => {
      return item.stock_take.id || item.stock_take.draft_quantity || parseFloat(item.stock_take.draft_quantity) === 0;
    })
    .map(item => item.stock_take);

    return workshopAPI.patch('/stock_take', stock_takes, 'stock_take')
    .then(() => sessionObjAPI.refresh());
  };

  $scope.$watch('[sorts.fields, sorts.directions]', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      $scope.savePage()
      .then(() => $scope.getPage())
      .then(() => gridAPI.updatePreferences($scope.grid));
    }
  }, true);

  $scope.$watch('[paging.pageSize, paging.currentPage]', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      $scope.savePage()
      .then(() => $scope.getPage())
      .then(() => gridAPI.updatePreferences($scope.grid));
    }
  }, true);

  $scope.$watch('[filters.begin_item, filters.end_item, filters.location, filters.product_type, filters.product_group, filters.vendor]', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      $scope.grid = gridAPI.resetCurrentPage($scope.grid);

      $scope.savePage()
      .then(() => $scope.getPage())
      .then(() => gridAPI.updatePreferences($scope.grid));
    }
  }, true);

  $scope.$watch('[filters.show_reserve, filters.count_excludes_reserved]', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      $scope.grid = gridAPI.resetCurrentPage($scope.grid);

      $scope.savePage()
      .then(() => {
        gridAPI.updatePreferences($scope.grid);
        $state.reload();
      });
    }
  }, true);

  $transitions.onStart({}, transition => {
    return $rootScope.session.flags.unprocessed_stock_take
      && $scope.confirmNav
      ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.STOCKTAKE_WARNING'))
      .then(() => {
        $scope.confirmNav = false;

        return true;
      })
      .catch(() => false)
      : true;
  });

  gridAPI.init($scope.products, $scope.grid);
};